import React from "react";
import { Roboto_Slab } from "next/font/google";
import Link from "next/link";

const robotoSlab = Roboto_Slab({
    subsets: ["latin"],
    weight: ["400", "600", "700"],
});

export default function AboutMe() {
    return (
        <>
            <div>
                <section id="home" className="hero_section">
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                    <span className="hspan"></span>
                </section>
            </div>
            <div>
                <br />
                <br />
               
              
                <div className="flex justify-center md:mb-20 md:mt-20 ">
                    <div className="flex w-full justify-center flex-col md:flex-row items-center">
                        <div className="p-3">
                            <img src="Aman.png" className="image-style" alt="Aman Gupta" />
                        </div>
                        <div className=" p-3 md:ml-5 z-50 relative mt-10 text-center md:text-left" >
                            <h2 className={` ${robotoSlab.className} text-5xl `}>
                                Aman D. Gupta
                            </h2>
                            <div className="ml-1">

                                <h2 className="text-mytext">I'm a Engineer.</h2>
                                <div>
                                    <p>View My Resume <span className="cursor-pointer text-blue-700 hover:underline"> <Link href="/amangupta.pdf" target="_blank" rel="noopener noreferrer">[ View ]</Link></span></p>
                                </div>
                            </div>
                            <div>
                                <br />
                            </div>
                            <div className="flex mt-5 justify-center md:justify-start">
                                <div>
                                    <Link href="https://www.linkedin.com/in/imaman-gupta/" target="_blank" aria-label="Visit my LinkedIn profile">
                                        <img src="linkedin.svg" className="w-13 cursor-pointer" alt="LinkedIn Profile" title="https://www.linkedin.com/in/imaman-gupta/" />
                                    </Link>
                                </div>
                                <div>
                                    <Link href="https://github.com/aman-devx" target="_blank" aria-label="Visit my github profile">
                                        <img src="github.svg" className="w-13 cursor-pointer" alt="Github" />
                                    </Link>
                                </div>
                                <div>
                                    <Link href="https://x.com/amanguptax_" target="_blank" aria-label="Visit my x profile">
                                        <img src="twitter.svg" className="w-13 cursor-pointer" alt="x.com" />
                                    </Link>
                                </div>
                                   <div>
                                    <Link href="https://www.instagram.com/amangupta0_/" target="_blank" aria-label="Visit my Instagramprofile">
                                        <img src="instagram.svg" className="w-13 cursor-pointer" alt="instagram" />
                                    </Link>
                                </div>
                                <div>
                                    <Link href="https://t.me/amandevx" target="_blank" aria-label="my telegram">
                                        <img src="telegram.svg" className="w-13 cursor-pointer" alt="telegram" />
                                    </Link>
                                </div>
                             
                                <div>
                                    <Link href="" aria-label="my Email">
                                        <img src="envelope.svg" className="w-13 cursor-pointer" alt="email" title="aman.gupta.devv@gmail.com"/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


               
               
                <br />
                <br />

                <hr className="hr_image" />
            </div>
        </>

    );
}
